import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceStatusBadge'
})
export class InvoiceStatusBadgePipe implements PipeTransform {

  transform(status: string): string {
    switch (status) {
      case 'PENDING':
        return 'bg-orange-100 text-orange-800 border border-orange-200 leading-tight';
      case 'PENDING_CONFIRMED':
        return 'bg-blue-100 text-blue-800 border border-blue-200 leading-tight';
      case 'SETTLED':
        return 'bg-green-100 text-green-800 border border-green-200 leading-tight';
      case 'CANCELLED':
        return 'bg-red-100 text-red-800 border border-red-200 leading-tight';
      default:
        return 'bg-gray-100 text-gray-800 border border-gray-200 leading-tight';
    }
  }
}
